import { render, staticRenderFns } from "./Archive_Items.vue?vue&type=template&id=237c30d4&"
import script from "./Archive_Items.vue?vue&type=script&lang=js&"
export * from "./Archive_Items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports